var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93699 2H19.5312C19.8074 2 20.0312 2.22386 20.0312 2.5C20.0312 2.77614 19.8074 3 19.5312 3H5.93699C5.71497 3.86261 4.93192 4.5 4 4.5C3.06808 4.5 2.28503 3.86261 2.06301 3H0.5C0.223858 3 0 2.77614 0 2.5C0 2.22386 0.223858 2 0.5 2H2.06301C2.28503 1.13739 3.06808 0.5 4 0.5C4.93192 0.5 5.71497 1.13739 5.93699 2ZM19.5312 8.90625C19.8074 8.90625 20.0312 8.68239 20.0312 8.40625C20.0312 8.13011 19.8074 7.90625 19.5312 7.90625H17.9104C17.6575 7.0916 16.8978 6.5 16 6.5C15.1022 6.5 14.3425 7.0916 14.0896 7.90625H0.5C0.223858 7.90625 0 8.13011 0 8.40625C0 8.68239 0.223858 8.90625 0.5 8.90625H14.0413C14.229 9.81603 15.0346 10.5 16 10.5C16.9654 10.5 17.771 9.81603 17.9587 8.90625H19.5312ZM20.0312 14.5C20.0312 14.7761 19.8074 15 19.5312 15H11.937C11.715 15.8626 10.9319 16.5 10 16.5C9.06808 16.5 8.28503 15.8626 8.06301 15H0.5C0.223858 15 0 14.7761 0 14.5C0 14.2239 0.223858 14 0.5 14H8.06301C8.28503 13.1374 9.06808 12.5 10 12.5C10.9319 12.5 11.715 13.1374 11.937 14H19.5312C19.8074 14 20.0312 14.2239 20.0312 14.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.8f9642a2135b7d8909cfac32d53ab702.svg";
export { ForwardRef as ReactComponent };